<template>
  <div style="display:flex;height:100%">
    <!-- 好友列表 -->
    <list
      ref="list"
      :user-list="userList"
      :session="session"
      :session-index.sync="sessionIndex"
      :search="search"
      @isRead="$emit('isRead')"
      @emptyShow="$emit('emptyShow')"
    ></list>
    <div style="flex:1;background-color:#fefefe;height: 99.5%;border-bottom: 1px solid #999;">
      <div style="border-bottom: 1px solid rgb(204, 204, 204);display: flex;justify-content: space-between;">
        <div class="message-head" style="padding: 21.5px 21px;box-sizing: border-box;flex: 3;">
          <span v-if="isFriend && !isemptyShow">{{userList.length>0 ? !isFriend ? ' ' : userList.filter(item => item.id === session.userId)[0].name : ' '}}</span>
          <span v-else>&nbsp;</span>
        </div>
        <span style="flex: 1;display: flex;justify-content: space-around;align-items: center;">
          <img style="cursor: pointer;" :src="require('@/assets/images/mini.png')" alt="最小化" @click="$emit('close')">
          <img style="cursor: pointer;" :src="require('@/assets/images/react.png')"  @click="$emit('toggleFullScreen')">
          <img style="cursor: pointer;" :src="require('@/assets/images/close.png')" alt="关闭" @click="$emit('close')">
        </span>
      </div>
      <!-- 消息展示 -->
      <message :session="session" :user="user" :user-list="userList" v-show='isFriend && !isemptyShow' ref="messagedom"></message>
      <!-- 发送消息框 -->
      <texts 
        v-show='isFriend && !isemptyShow'
        :user-list="userList" 
        :session="session" 
        :isemptyShow="isemptyShow"
        :user="user" 
        ref="texts" 
        @hasNewFriend="$emit('hasNewFriend')" 
        @updateMsg="(data)=>{$emit('updateMsg',data)}" 
        @changebadge="(value)=>{$emit('changebadge',value);$refs.messagedom.clickActive = null}"
        @updatebadge="$emit('updatebadge')"></texts>
      <div v-if="showMemo ? false : (isemptyShow && isFriend)?isemptyShow:(!isFriend && !showFriendsList)" class="emptyTemp">
        <img :src="require('@/assets/images/logo.png')" alt="">
      </div>
    </div>
  </div>
</template>

<script>
// 好友列表
import list from "./list";
// 发送消息框
import texts from "./texts";
// 消息展示
import message from './message';
let vm = {};
export default {
  props: ["userList", "sessionIndex", "session", "search", "choose", "user","isemptyShow","isFriend","showFriendsList","showMemo"],
  components: {
    texts,
    list,
    message
  },
  data() {
    vm = this;
    return {
    };
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.emptyTemp{
  height: 89%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>


// WEBPACK FOOTER //
// src/components/vueChart/ChatSession.vue